/**
 * This file is auto-generated from LanguagePicker.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const selectLanguage: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Select language';
        case 'pl':
            return 'Wybierz język';
    }
};
